
/**
 * Utility functions for handling movie images - CLEANED UP: Pure camelCase only
 */

/**
 * Gets a valid poster URL from camelCase movie properties
 * @param movie A movie object with posterPath in camelCase
 * @returns A valid poster URL or undefined
 */
export function getPosterUrl(movie: { 
  posterPath?: string | null;
}): string | undefined {
  const posterPath = movie.posterPath;
  
  // If posterPath exists, convert it to a full URL
  if (posterPath) {
    // Check if it's already a full URL
    if (posterPath.startsWith('http')) {
      return posterPath;
    }
    return `https://image.tmdb.org/t/p/w500${posterPath}`;
  }
  
  // No poster available
  return undefined;
}

/**
 * Gets a smaller thumbnail version of the poster
 * @param movie A movie object with posterPath in camelCase
 * @returns A valid thumbnail URL or undefined
 */
export function getThumbnailUrl(movie: { 
  posterPath?: string | null;
}): string | undefined {
  const posterPath = movie.posterPath;
  
  // If posterPath exists, convert it to a smaller thumbnail URL
  if (posterPath) {
    // Check if it's already a full URL
    if (posterPath.startsWith('http')) {
      return posterPath; // Can't resize external URLs
    }
    return `https://image.tmdb.org/t/p/w92${posterPath}`;
  }
  
  // No poster available
  return undefined;
}

/**
 * Normalizes image paths to ensure consistent camelCase format
 * CLEANED UP: No more snake_case compatibility
 */
export function normalizeImagePaths<T extends Record<string, any>>(movie: T): T {
  if (!movie) return movie;
  
  // Simply return the movie as-is since we expect pure camelCase input
  return movie;
}
